/** get items column */
import { Tag } from "antd";

export const columns = () => {
  return [
    {
      title: "ชนิด",
      key: "item_type",
      dataIndex: "item_type",
      width: "8%",
      align: "center",
      render: (v) =>
        (v || "PG") === "FG" ? (
          <Tag color="purple">FG</Tag>
        ) : (
          <Tag color="blue">PG</Tag>
        ),
    },
    {
      title: "รหัสสินค้า",
      key: "pg_code",
      dataIndex: "pg_code",
      width: "15%",
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "pg_name",
      key: "pg_name",
      width: "27%",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: "15%",
    },
  ];
};
